import experianServiceNames from "./Experian/getExperianServiceNames";

const TYPE_LABELS = {
  SAN: {
    label: "Sanctions",
    title: "Sanctions (SAN)",
  },
  PEP: {
    label: "Politically Exposed Person",
    title: "Politically Exposed Person (PEP)",
  },
  RCA: {
    label: "Relatives and Close Associates",
    title: "Relatives and Close Associates (RCA)",
  },
};

const TYPE_DISPLAY_ORDER = ["SAN", "PEP", "RCA"];

const PEP_SERVICE_NAME = "uk-pepsanc";
const PEP_DECISION_SOURCE = "uk-pepsanc";

const TYPE_ORDER = ["PEP", "SAN", "RCA"];

const NON_MATCH_REASONS = [
  "Not your client due to Full name",
  "Not your client due to Date of Birth",
  "Not your client  due to Region",
  // "Not your client due to Position",
  "Not your client due to Occupation Category",
  "Not your client due to Association Type",
  "This is my client",
];

const RCA_NON_MATCH_REASONS = [
  "The RCA is a correct match",
  "The RCA is not a Match",
];

export const DOB_MISMATCH_REASON = "Not your client due to Date of Birth";

const API_BASE = process.env.REACT_APP_AML_SERVER;
const TYPE_MAP = { enhanced: "enhanced", standard: "standard" };

const EXPERIAN_ABBREVIATIONS = {
  CAPS: "Credit Application Previous Searches",
  CAIS: "Credit Account Information Sharing",
  PEP: "Politically Exposed Person",
  SAN: "Sanctions Lists",
  RCA: "Relative or Close Associate",
  SIE: "Special Interest Entity",
  CCWS: "CrossCore Watchlist Screening",
  SIP: "Special Interest Person",
  RDM: "Reference Data Matching",
};

const CHECK_TYPE_LABELS = {
  pep_sanctions: "PEP & Sanctions",
  simple: "Simple",
  enhanced: "Enhanced",
  idv: "Identity Verification",
};

const MY_CLIENT_REASON = [
  "This is my client",
  "This is my Client",
  "Refer to Compliance",
  "The RCA is a correct match",
  "This relates is my client",
];
const MORTALITY_SERVICE = experianServiceNames.CREDIT_REFERENCE; 
// OR "uk-crpverify" — just pick ONE and use it everywhere
// console.log("Using mortality service name(s):", MORTALITY_SERVICE);
export {
  TYPE_LABELS,
  PEP_SERVICE_NAME,
  PEP_DECISION_SOURCE,
  NON_MATCH_REASONS,
  TYPE_ORDER,
  API_BASE,
  TYPE_MAP,
  TYPE_DISPLAY_ORDER,
  EXPERIAN_ABBREVIATIONS,
  CHECK_TYPE_LABELS,
  MY_CLIENT_REASON,
  MORTALITY_SERVICE,
  RCA_NON_MATCH_REASONS,
};
